module.exports = __webpack_public_path__ + "cd33f84df75b7bbc2239f21f44156ac4.svg";